import { Stack } from 'expo-router'

/**
 * Кабинет внешнего пользователя — свой слой-обёртка БЕЗ корпоративной навигации: у
 * поставщика нет ни ленты, ни оргструктуры, ни процессов, и показывать ему пустые разделы
 * портала незачем. Провайдеры (тема, язык, запросы, авторизация) приходят из корневого
 * слоя, поэтому здесь только навигатор.
 */
export default function CabinetLayout() {
  return <Stack screenOptions={{ headerShown: false }} />
}
